import React from 'react';
export function TermsPage() {
  return <div className="min-h-screen bg-white py-12 px-6" data-id="element-538">
      <div className="max-w-3xl mx-auto" data-id="element-539">
        <div className="mb-8" data-id="element-540">
          <h1 className="text-4xl font-bold text-[#2C3E50] mb-4" data-id="element-541">
            Términos y Condiciones de Uso
          </h1>
        </div>

        <div className="space-y-6 text-[#2C3E50]" data-id="element-542">
          <div className="bg-[#E8F4F8] border-l-4 border-[#5B9BD5] p-4 rounded" data-id="element-543">
            <p className="font-semibold text-lg" data-id="element-544">Tarjeta EMPRENDE FULLPASS</p>
          </div>

          <section data-id="element-545">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-546">
              1. NATURALEZA DEL PROGRAMA
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-547">
              El presente documento establece los términos y condiciones
              aplicables al uso de la tarjeta de fidelización gratuita
              denominada EMPRENDE FULLPASS (en adelante, "la Tarjeta"), la cual
              permite a sus titulares acceder a beneficios, descuentos y
              promociones ofrecidos por comercios afiliados al programa.
            </p>
          </section>

          <section data-id="element-548">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-549">
              2. ACCESO A LA TARJETA
            </h2>
            <ul className="space-y-2 text-gray-700 leading-relaxed" data-id="element-550">
              <li className="flex gap-2" data-id="element-551">
                <span className="text-[#5B9BD5] font-bold" data-id="element-552">•</span>
                <span data-id="element-553">
                  La Tarjeta es gratuita y de uso personal e intransferible.
                </span>
              </li>
              <li className="flex gap-2" data-id="element-554">
                <span className="text-[#5B9BD5] font-bold" data-id="element-555">•</span>
                <span data-id="element-556">
                  Podrá acceder a ella cualquier persona natural mayor de edad
                  que complete el formulario de afiliación correspondiente.
                </span>
              </li>
              <li className="flex gap-2" data-id="element-557">
                <span className="text-[#5B9BD5] font-bold" data-id="element-558">•</span>
                <span data-id="element-559">
                  El uso de la Tarjeta implica la aceptación plena de estos
                  términos y condiciones.
                </span>
              </li>
            </ul>
          </section>

          <section data-id="element-560">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-561">
              3. BENEFICIOS Y PROMOCIONES
            </h2>
            <ul className="space-y-2 text-gray-700 leading-relaxed" data-id="element-562">
              <li className="flex gap-2" data-id="element-563">
                <span className="text-[#5B9BD5] font-bold" data-id="element-564">•</span>
                <span data-id="element-565">
                  Los beneficios ofrecidos pueden incluir: descuentos directos,
                  promociones especiales, servicios preferenciales, obsequios u
                  otros incentivos, según lo determine cada comercio afiliado.
                </span>
              </li>
              <li className="flex gap-2" data-id="element-566">
                <span className="text-[#5B9BD5] font-bold" data-id="element-567">•</span>
                <span data-id="element-568">
                  Cada comercio es el único responsable de aplicar, mantener,
                  modificar o cancelar los beneficios que ofrece a los usuarios
                  de la Tarjeta.
                </span>
              </li>
              <li className="flex gap-2" data-id="element-569">
                <span className="text-[#5B9BD5] font-bold" data-id="element-570">•</span>
                <span data-id="element-571">
                  Los beneficios están sujetos a condiciones particulares
                  propias de cada comercio (vigencia, stock, montos mínimos de
                  compra, restricciones, etc.).
                </span>
              </li>
            </ul>
          </section>

          <section data-id="element-572">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-573">
              4. RESPONSABILIDAD DEL PROGRAMA
            </h2>
            <ul className="space-y-2 text-gray-700 leading-relaxed" data-id="element-574">
              <li className="flex gap-2" data-id="element-575">
                <span className="text-[#5B9BD5] font-bold" data-id="element-576">•</span>
                <span data-id="element-577">
                  TicketMaestro y su Plataforma Benefica en su rol de procesador
                  de La Tarjeta, y la Cámara Ecuatoriana de Desarrollo
                  Sostenible (CEDES), actúan únicamente como intermediarios que
                  conectan a los usuarios con comercios aliados, sin asumir
                  responsabilidad por la calidad, disponibilidad o condiciones
                  de los productos o servicios ofrecidos.
                </span>
              </li>
              <li className="flex gap-2" data-id="element-578">
                <span className="text-[#5B9BD5] font-bold" data-id="element-579">•</span>
                <span data-id="element-580">
                  En caso de cualquier inconveniente o reclamo relacionado con
                  los beneficios, el usuario deberá comunicarse directamente con
                  el comercio correspondiente.
                </span>
              </li>
            </ul>
          </section>

          <section data-id="element-581">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-582">
              5. VIGENCIA Y MODIFICACIONES
            </h2>
            <ul className="space-y-2 text-gray-700 leading-relaxed" data-id="element-583">
              <li className="flex gap-2" data-id="element-584">
                <span className="text-[#5B9BD5] font-bold" data-id="element-585">•</span>
                <span data-id="element-586">
                  La vigencia de la Tarjeta es indefinida, salvo que el usuario
                  o la organización emiten renuncien expresamente a su uso.
                </span>
              </li>
              <li className="flex gap-2" data-id="element-587">
                <span className="text-[#5B9BD5] font-bold" data-id="element-588">•</span>
                <span data-id="element-589">
                  La organización se reserva el derecho de modificar, suspender
                  o cancelar el programa o sus términos y condiciones,
                  informando oportunamente a los usuarios a través de sus
                  canales oficiales.
                </span>
              </li>
            </ul>
          </section>

          <section data-id="element-590">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-591">
              6. PROTECCIÓN DE DATOS PERSONALES
            </h2>
            <ul className="space-y-2 text-gray-700 leading-relaxed" data-id="element-592">
              <li className="flex gap-2" data-id="element-593">
                <span className="text-[#5B9BD5] font-bold" data-id="element-594">•</span>
                <span data-id="element-595">
                  Al afiliarse, el usuario autoriza el tratamiento de sus datos
                  personales conforme a la legislación vigente, exclusivamente
                  para fines informativos y promocionales relacionados con el
                  programa.
                </span>
              </li>
              <li className="flex gap-2" data-id="element-596">
                <span className="text-[#5B9BD5] font-bold" data-id="element-597">•</span>
                <span data-id="element-598">
                  Los datos no serán compartidos con terceros sin consentimiento
                  del titular, salvo requerimiento legal. Puede ver más detalles
                  en el documento de nuestras Políticas de Privacidad y
                  Protección de Datos Personales.
                </span>
              </li>
            </ul>
          </section>

          <section data-id="element-599">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-600">
              7. USO INDEBIDO Y CANCELACIÓN
            </h2>
            <ul className="space-y-2 text-gray-700 leading-relaxed" data-id="element-601">
              <li className="flex gap-2" data-id="element-602">
                <span className="text-[#5B9BD5] font-bold" data-id="element-603">•</span>
                <span data-id="element-604">
                  El uso fraudulento, indebido o contrario a estos términos
                  puede dar lugar a la anulación inmediata de la Tarjeta y la
                  pérdida de sus beneficios.
                </span>
              </li>
              <li className="flex gap-2" data-id="element-605">
                <span className="text-[#5B9BD5] font-bold" data-id="element-606">•</span>
                <span data-id="element-607">
                  La organización podrá retirar o suspender la tarjeta en caso
                  de mal uso sin necesidad de notificación previa.
                </span>
              </li>
            </ul>
          </section>

          <section data-id="element-608">
            <h2 className="text-xl font-semibold mb-3 text-[#5B9BD5]" data-id="element-609">
              8. VIGENCIA
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-610">
              La vigencia de estos Términos y Condiciones de Uso es desde el 12
              de septiembre de 2025 y permanecerá vigente hasta que exista una
              nueva versión que la reemplace.
            </p>
          </section>
        </div>
      </div>
    </div>;
}